<template>
  <v-row no-gutters>
    <v-col v-for="(v, f) in types" :cols="cols" :md="md" :lg="lg" v-bind:key="f">

      <v-checkbox v-model="types[f]"
                  @change='updateValue'
                  color="primary"
                  :ripple="false"
                  hide-details>

        <template v-slot:label>
          {{$t(`estates.categories.${f}`)}}
        </template>
      </v-checkbox>

    </v-col>
  </v-row>
</template>

<script>
import estateTypes from '@/common/mixins/estates/estate-types-mixin'

export default {
  name: 'TypesSearch',

  props: {
    value: {
      type: [Array, String],
      default: () => []
    },

    cols: {
      type: Number,
      default: 6
    },

    md: {
      type: Number,
      default: 4
    },

    lg: {
      type: Number,
      default: 3
    }
  },

  mixins: [estateTypes],

  methods: {
    updateValue () {
      this.$emit('input', this.activeTypes)
    }
  },

  created () {
    this.activeTypes = Array.isArray(this.value) ? this.value : this.value.split(',')
  }
}
</script>

<style lang="scss">
</style>
